import { Component, OnInit } from '@angular/core';
import { SessionStateService } from '../../../../core/services/session-state.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss']
})
export class OnboardingComponent implements OnInit {
  selectedTab;
  constructor(private sessionStateService: SessionStateService,
              private router: Router) { }

  ngOnInit() {
    this.selectedTab = 1;
  }

  nextTab() {
    if (this.selectedTab === 7) {
      this.start();
    } else {
      this.selectedTab++;
    }
  }

  get2StepImg() {
    const lang = this.sessionStateService.getLang();
    switch (lang) {
      case 'ES':
        return '../assets/img/icons/ilust-onboarding-check-es.svg';
      case 'PT':
        return '../assets/img/icons/ilust-onboarding-check-pt.svg';
      case 'EN':
        return '../assets/img/icons/ilust-onboarding-check-en.svg';
      default:
        return '../assets/img/icons/ilust-onboarding-check-pt.svg';
    }
  }

  get3StepImg() {
    const lang = this.sessionStateService.getLang();
    switch (lang) {
      case 'ES':
        return '../assets/img/icons/ilust-onboarding-monitor-es.svg';
      case 'PT':
        return '../assets/img/icons/ilust-onboarding-monitor-pt.svg';
      case 'EN':
        return '../assets/img/icons/ilust-onboarding-monitor-en.svg';
      default:
        return '../assets/img/icons/ilust-onboarding-monitor-pt.svg';
    }
  }

  get4StepImg() {
    const lang = this.sessionStateService.getLang();
    switch (lang) {
      case 'ES':
      return '../assets/img/icons/ilust-onboarding-control-es.svg';
      case 'PT':
      return '../assets/img/icons/ilust-onboarding-control-pt.svg';
      case 'EN':
        return '../assets/img/icons/ilust-onboarding-control-en.svg';
      default:
        return '../assets/img/icons/ilust-onboarding-control-pt.svg';
    }
  }
  get5StepImg() {
    const lang = this.sessionStateService.getLang();
    switch (lang) {
      case 'ES':
      return '../assets/img/icons/ilust-onboarding-detail-es.svg';
      case 'PT':
      return '../assets/img/icons/ilust-onboarding-detail-pt.svg';
      case 'EN':
      return '../assets/img/icons/ilust-onboarding-detail-en.svg';
      default:
      return '../assets/img/icons/ilust-onboarding-detail-pt.svg';
    }
  }

  get6StepImg() {
    const lang = this.sessionStateService.getLang();
    switch (lang) {
      case 'ES':
      return '../assets/img/icons/ilust-onboarding-scheduling-es.svg';
      case 'PT':
      return '../assets/img/icons/ilust-onboarding-scheduling-pt.svg';
      case 'EN':
      return '../assets/img/icons/ilust-onboarding-scheduling-en.svg';
      default:
      return '../assets/img/icons/ilust-onboarding-scheduling-pt.svg';
    }
  }

  get7StepImg() {
    const lang = this.sessionStateService.getLang();
    switch (lang) {
      case 'ES':
      return '../assets/img/icons/ilust-onboarding-characterization-es.svg';
      case 'PT':
      return '../assets/img/icons/ilust-onboarding-characterization-pt.svg';
      case 'EN':
      return '../assets/img/icons/ilust-onboarding-characterization-en.svg';
      default:
      return '../assets/img/icons/ilust-onboarding-characterization-pt.svg';
    }
  }

  skipOnboarding() {
    this.router.navigate(['/home']);
  }

  start() {
    this.router.navigate(['/profile/house-characterization']);
  }

  getBtnText() {
    if (this.selectedTab < 7) {
      return 'NEXT';
    } else {
      return 'START';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/coachmarks/onboarding/onboarding.component.ts